import DashboardGenComponent from "@/components/DashboardGenComponent.tsx";
import {useNavigate, useParams} from "react-router-dom";
import st from "@/styles/VerifyAccount.module.scss"
import {useTranslation} from "react-i18next";
import useAuth from "@/hooks/auth.ts";
import KYCStepOne from "@/pages/kyc/steps/KYCStepOne.tsx";
import React, {useEffect, useRef} from "react";
import StepsInterface from "@/types_and_interfaces/sidebar_steps_interface.ts";
import InFramesUser from "@/svg/InFramesUser.tsx";
import TickUserIcon from "@/svg/TickUserIcon.tsx";
import KYCStepTwo from "@/pages/kyc/steps/KYCStepTwo.tsx";
import DashboardClass from "@/utils/dashboard_class.ts";
import {useAtom} from "jotai/index";
import {open_notifications_sidebar, profile} from "@/atoms/profile.ts";
import eventEmitter from "@/utils/event_emmiter_instance.ts";
import CommonClass from "@/utils/common.ts";


const KYCPage = () => {

    const {step} = useParams()
    const {t} = useTranslation()
    const auth = useAuth()
    const navigate = useNavigate()
    const [user] = useAtom(profile)
    const userLoaded = useRef<boolean>(false)
    const ran = useRef(false)
    const consent_ran = useRef(false)
    const [_, setOpenNotifications] = useAtom(open_notifications_sidebar)

    let steps:Array<StepsInterface> = [
        
        {
            label: t("show_id"),
            icon: <InFramesUser />
        },
        
        {
            label: t("confirm_identity"),
            icon: <TickUserIcon />
        },
        
    ]

    const isUserLoaded = user && typeof user === "object" && user.id !== undefined;

    useEffect(() => {
        if (location.pathname.startsWith("/kyc")) {
            setOpenNotifications(false)
        }
    }, [location.pathname]);

    useEffect(() => {
        if (!isUserLoaded) return;

        if(typeof user === "object" && (user?.auth_type === "ByMPass" || !user?.permissions.is_kyc_allowed) && (step === "1" || step === "2")) {
            if(!ran.current) {
                // eventEmitter.emit(CommonClass.CustomEvents.update_snackbar, "info", t("can_not_go_to_kyc"))
                ran.current = true
            }
            
            navigate(DashboardClass.dashboard_routes.Home)
        }
        
        if(user?.kyc_general_status === "ProcessingFailedAndSentToManager" ||
            (user?.kyc_general_status === "ProcessingSuccess" && !(user?.has_asp_kyc_conflict || user?.identity_card_is_expired || user?.identity_card_is_expiring_soon)
        )) {
            navigate(DashboardClass.dashboard_routes.Home)

        } else if(user?.kyc_general_status === "Expired" || (user?.kyc.identity_card === "ProcessingFailed" && user?.kyc.liveness === "Unknown" && step === "2")){
            navigate(DashboardClass.dashboard_routes.KYC + "/1")

        } else if(user?.kyc.identity_card === "ProcessingSuccess" && user?.kyc.liveness !== "ProcessingSuccess" && step === "1"){
            navigate(DashboardClass.dashboard_routes.KYC + "/2")
            
        } else if(user?.kyc_general_status === "Unknown") {
            
            if(!consent_ran.current) {
                eventEmitter.emit(CommonClass.ModalEvents.OpenDataConsent, true)
                consent_ran.current = true
            }
            
        }
        
        if(typeof user === "object") {
            
            if(!userLoaded.current){
                
                if(user.kyc_general_status === "UserFinished" || user.kyc_general_status === "ServerProcessing") {
                    navigate(DashboardClass.dashboard_routes.KYCWaitingRoom)
                    
                }
                
                userLoaded.current = true
            }
        }
        
    }, [user, isUserLoaded]);

    return (
        <DashboardGenComponent
            steps={steps}
            
            centered_content
            
            header_type={"primary"}
            
            onBackClick={() => {
                navigate(-3)
            }}
            
            heading={
                <div>
                    {t("welcome")}

                    <span className={st.phone_number}>
                        {auth.getUserNaming()}
                    </span>

                </div>
            }
            
            header_content={
                <div className={st.header_content}>
                    
                    {step === "1" && (
                        <h4>
                            {t("show_document")}
                        </h4>
                    )}
                    
                    {step === "2" && (
                        <h4>
                            {t("verify_identity")}
                        </h4>
                    )}
                    
                </div>
            }
            
            column_center={
                <div className={st.mother_container}>
                    {step ? <Steps step={step}/> : null}
                </div>
            }
        />
    )
}





interface KYCStepsInterface {
    step: string
}

const Steps: React.FC<KYCStepsInterface> = ({step}) => {
    
    return (
        <>
            {step === "1" && <KYCStepOne/>}
            {step === "2" && <KYCStepTwo/>}
        </>
    )
}

export default KYCPage